// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1maFS","type":"styles_type__naXQZ","choices":"styles_choices__3jHZm"};